import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { useJumpLink } from '../../../../hooks';
import PricingCard from '../PricingCard';
import Button from '../../../Core/Button';

import {
  Cards,
  StyledButtonLink,
  StyledContainer,
  StyledLink,
  Wrapper,
} from './styles';

function PricingSection({ data }) {
  if (!data) return null;
  const {
    ariaLabelCTA,
    colourOverrideBackground,
    cta,
    ctaText,
    items,
    leftToggle,
    queryStringCTA,
    rightToggle,
    sectionStyle,
    subTitleHtml,
    titleHtml,
  } = data;

  useJumpLink();
  // toggle left and right set of cards with toggle button
  const [showLeft, setShowLeft] = useState(true);
  const [showRight, setShowRight] = useState(false);

  const handleLeftToggleClick = () => {
    setShowLeft(true);
    setShowRight(false);
  };

  const handleRightToggleClick = () => {
    setShowRight(true);
    setShowLeft(false);
  };
  // show and hide first and third cards with buttons (mobile only)
  const [showFirstCardLeft, setShowFirstCardLeft] = useState(false);
  const [showFirstCardRight, setShowFirstCardRight] = useState(false);
  const [showThirdCardLeft, setShowThirdCardLeft] = useState(false);
  const [showThirdCardRight, setShowThirdCardRight] = useState(false);

  const handleFirstCardLeftClick = () => {
    setShowFirstCardLeft(true);
  };

  const handleThirdCardLeftClick = () => {
    setShowThirdCardLeft(true);
  };

  const handleFirstCardRightClick = () => {
    setShowFirstCardRight(true);
  };

  const handleThirdCardRightClick = () => {
    setShowThirdCardRight(true);
  };

  return (
    <Wrapper
      id="pricing-details"
      colourOverrideBackground={colourOverrideBackground}
    >
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        {ReactHtmlParser(subTitleHtml)}
        {sectionStyle === 'Toggle' && (
          <div className="toggleContainer">
            <Button
              className={[
                'solid-on-light-bg',
                'left-toggle',
                showLeft ? 'active' : 'inactive',
              ]}
              onClick={handleLeftToggleClick}
            >
              {leftToggle}
            </Button>
            <Button
              className={[
                'ghost-on-light-bg',
                'right-toggle',
                showRight ? 'active' : 'inactive',
              ]}
              onClick={handleRightToggleClick}
            >
              {rightToggle}
            </Button>
          </div>
        )}
        {/* if no toggle render cards in one row */}
        {(sectionStyle === null || sectionStyle !== 'Toggle') && (
          <Cards spacing="10px" columns={items.length}>
            {items.map((item, index) => (
              <PricingCard
                data={item}
                key={`pricing-card-${index.toString()}`}
              />
            ))}
          </Cards>
        )}
        {/* show the frist group of cards when the left toggle is clicked */}
        {sectionStyle === 'Toggle' && showLeft && (
          <>
            <Button
              className={[
                'solid-on-light-bg',
                'FirstCardLeftButton',
                showFirstCardLeft ? 'hideButton' : 'show',
              ]}
              onClick={handleFirstCardLeftClick}
            >
              Show More
            </Button>
            <Cards
              spacing="10px"
              columns={items.length}
              className={[
                showFirstCardLeft ? 'showFirstCardLeft' : 'hideFirstCardLeft',
                showThirdCardLeft ? 'showThirdCardLeft' : 'hideThirdCardLeft',
              ]}
            >
              {items.map((item, index) => {
                if (item.cardGroup === 'priceCardItemsGroup1') {
                  return (
                    <PricingCard
                      data={item}
                      key={`pricing-card-${index.toString()}`}
                    />
                  );
                }
                return null;
              })}
            </Cards>
            <Button
              className={[
                'solid-on-light-bg',
                'ThirdCardLeftButton',
                showThirdCardLeft ? 'hideButton' : 'show',
              ]}
              onClick={handleThirdCardLeftClick}
            >
              Show More
            </Button>
            {/* if button is active, show the third card */}
            {/* if button is inactive, hide the third card */}
          </>
        )}
        {/* show the second group of cards when the right toggle is clicked */}
        {sectionStyle === 'Toggle' && showRight && (
          <>
            <Button
              className={[
                'solid-on-light-bg',
                'FirstCardRightButton',
                showFirstCardRight ? 'hideButton' : 'show',
              ]}
              onClick={handleFirstCardRightClick}
            >
              Show More
            </Button>
            <Cards
              spacing="10px"
              columns={items.length}
              className={[
                showFirstCardRight
                  ? 'showFirstCardRight'
                  : 'hideFirstCardRight',
                showThirdCardRight
                  ? 'showThirdCardRight'
                  : 'hideThirdCardRight',
              ]}
            >
              {items.map((item, index) => {
                if (item.cardGroup === 'priceCardItemsGroup2') {
                  return (
                    <PricingCard
                      data={item}
                      key={`pricing-card-${index.toString()}`}
                    />
                  );
                }
                return null;
              })}
            </Cards>
            <Button
              className={[
                'solid-on-light-bg',
                'ThirdCardRightButton',
                showThirdCardRight ? 'hideButton' : 'show',
              ]}
              onClick={handleThirdCardRightClick}
            >
              Show More
            </Button>
          </>
        )}
        {ctaText && (
          <StyledLink
            to={cta.url}
            ariaLabel={ariaLabelCTA}            
          >
            <StyledButtonLink
              className="ghost-on-light-bg"
              queryString={queryStringCTA}
            >
              {ctaText}
            </StyledButtonLink>
          </StyledLink>
        )}
      </StyledContainer>
    </Wrapper>
  );
}

PricingSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

PricingSection.defaultProps = {};

export default PricingSection;
